import { c as _c } from "react/compiler-runtime";
import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { clientApi } from '../../configuration';
import { usePagination } from '../../utils';
type GetPaginatedAnalyticsParams = {
  id: string;
  code: 'SPARK_STUDENTS';
  itemsByPage?: number;
  defaultPage?: number;
  orderBy?: string;
  asCsv?: boolean;
  filters?: {
    displayableName?: string;
  };
  groupBy?: string;
};
export default function usePaginatedOrganizationAnalytics(t0) {
  const $ = _c(28);
  const {
    id: organizationId,
    code,
    filters,
    groupBy,
    orderBy,
    asCsv: t1,
    itemsByPage: t2,
    defaultPage: t3
  } = t0;
  const asCsv = t1 === undefined ? false : t1;
  const itemsByPage = t2 === undefined ? 10 : t2;
  const defaultPage = t3 === undefined ? 1 : t3;
  let t4;
  if ($[0] !== defaultPage || $[1] !== itemsByPage) {
    t4 = {
      itemsByPage,
      defaultPage
    };
    $[0] = defaultPage;
    $[1] = itemsByPage;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const [pagination, currentRange, getTotalPages] = usePagination(t4);
  const paginationRange = `${currentRange.start}-${currentRange.end}`;
  let t5;
  if ($[3] !== code || $[4] !== filters || $[5] !== groupBy || $[6] !== orderBy || $[7] !== paginationRange) {
    t5 = [{
      code,
      filters,
      orderBy,
      groupBy,
      pagination: paginationRange
    }];
    $[3] = code;
    $[4] = filters;
    $[5] = groupBy;
    $[6] = orderBy;
    $[7] = paginationRange;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== asCsv || $[10] !== organizationId || $[11] !== t5) {
    t6 = ["paginatedOrganizationAnalytics", organizationId, t5, asCsv];
    $[9] = asCsv;
    $[10] = organizationId;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== asCsv || $[14] !== code || $[15] !== filters || $[16] !== getTotalPages || $[17] !== groupBy || $[18] !== orderBy || $[19] !== organizationId || $[20] !== paginationRange) {
    t7 = async () => {
      const ocClient = clientApi.getOCClient();
      const {
        employer
      } = ocClient.helpers;
      const {
        body
      } = await employer.organizations.id(organizationId).analytics.find({
        reports: [{
          code,
          filters,
          orderBy,
          groupBy,
          pagination: paginationRange
        }],
        asCsv
      });
      const [t8] = body;
      const {
        data: items,
        pagination: responseHeaderPaginationLike
      } = t8;
      let totalItems = items.length;
      if (responseHeaderPaginationLike) {
        const headerData = responseHeaderPaginationLike.split("/");
        totalItems = +headerData[1];
      }
      return {
        items,
        totalItems,
        totalPages: getTotalPages(totalItems)
      };
    };
    $[13] = asCsv;
    $[14] = code;
    $[15] = filters;
    $[16] = getTotalPages;
    $[17] = groupBy;
    $[18] = orderBy;
    $[19] = organizationId;
    $[20] = paginationRange;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== t6 || $[23] !== t7) {
    t8 = {
      queryKey: t6,
      queryFn: t7,
      retry: 1,
      refetchOnWindowFocus: false,
      placeholderData: keepPreviousData
    };
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  const paginatedQueryResponse = useQuery(t8);
  let t9;
  if ($[25] !== paginatedQueryResponse || $[26] !== pagination) {
    t9 = {
      ...paginatedQueryResponse,
      pagination
    };
    $[25] = paginatedQueryResponse;
    $[26] = pagination;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  return t9;
}